

import React from 'react'
import './LiveAuction.css'

import {Container, Row, Col} from 'reactstrap'
import { Link } from 'react-router-dom'

// import img01 from '../../../assets/images/img-01.jpg'
// import ava01 from '../../../assets/images/ava-01.png'

import NftCard from '../NftCard/NftCard'
import {NFT__DATA} from '../../../assets/data/data.js'

const LiveAuction = () => {
  return (
   <section>
    <Container>
        <Row>
            <Col lg='12' className='mb-4'>
            <div className='live_auction_top d-flex align-items-center 
            justify-content-between'>
                <h3>Live Auction</h3>
                <span><Link to='/market'>Explore more</Link></span>
            </div>
            </Col>
          

            {
                NFT__DATA.slice(0,4).map((item) => (

                    <Col lg='3' md='4' sm='6' className='mb-4'>

                    <NftCard key={item.id} item={item} />

                    </Col>

                ))

            }





                {/* <div className='single_nft_card'>
                    <div className='nft_img'>
                    <img src={img01} alt="" className='w-100' />
                    </div>

                    <div className='nft_content'>
                        <h5 className='nft_title'>Travel Monkey Club</h5>
                        <div className='creator_info_wrapper d-flex gap-3'>
                            <div className='creator_img'>
                                <img src={ava01} alt='' className='w-100' />
                            </div>
                            <div className='creator_info w-100 d-flex align-items-center 
                            justify-content-between'>
                            <div >
                                <h6> Created by</h6>
                                <p>Zakir Hossain</p>
                            </div>
                            <div>
                                <h6> Current Bid</h6>
                                <p>7.17 ETH</p> 
                            </div>
                            </div>
                        </div>
                        <div className=' mt=3 d-flex align-items-center justify-content-between'>
                            <button className='bid_btn d-flex align-items-center gap-1'> 
                            <i class="ri-shopping-bag-line"></i> Place Bid</button>

                            <span className='history_link'>
                             <Link to='#'> View History</Link></span>
                        </div>



                    </div>
                </div> */}

          
        </Row>
    </Container>
   </section>
  )
}

export default LiveAuction